import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography, Button } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

const Impersonate: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const checkAuth = useAuthStore((state) => state.checkAuth);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setError('Missing impersonation token.');
      return;
    }

    localStorage.setItem('token', token);

    const validateToken = async () => {
      await checkAuth();
      const { isAuthenticated } = useAuthStore.getState();
      if (isAuthenticated) {
        navigate('/', { replace: true });
      } else {
        setError('Unable to authenticate impersonation token.');
      }
    };

    validateToken();
  }, [searchParams, checkAuth, navigate]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        backgroundColor: 'background.default',
        px: 3,
      }}
    >
      {error ? (
        <>
          <Typography variant="h6" color="error" textAlign="center">
            {error}
          </Typography>
          <Button variant="contained" onClick={() => navigate('/login')}>
            Back to Login
          </Button>
        </>
      ) : (
        <>
          <CircularProgress />
          <Typography variant="body1" color="text.secondary">
            Signing you in...
          </Typography>
        </>
      )}
    </Box>
  );
};

export default Impersonate;
